import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { personalInfo } from '../../data/content';

const BookSection = () => {
  const { book } = personalInfo;
  
  return (
    <section className="py-24 bg-slate-50 dark:bg-brand-darker border-y border-slate-200 dark:border-slate-800 overflow-hidden relative">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-stretch gap-16 lg:gap-24">
          <div className="w-full lg:w-1/2 flex">
            <div className="relative group w-full h-full">
              <div className="relative w-full h-full shadow-[0_30px_60px_rgba(0,0,0,0.15)] dark:shadow-[0_30px_60px_rgba(255,215,0,0.05)] rounded-lg overflow-hidden border border-white/20">
                <img
                  src={book.cover}
                  alt={book.title}
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="inline-block px-4 py-1.5 bg-brand-dark dark:bg-brand-yellow text-brand-yellow dark:text-brand-dark text-[10px] uppercase tracking-[0.3em] font-black mb-6 rounded shadow-lg">
              Bestselling Methodology
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-slate-900 dark:text-white mb-6 leading-tight">
              Escaping The Tool Trap™<br />
              <span className="text-brand-red">The Systematic Approach to Martech Consolidation</span>
            </h2>
            <p className="text-lg text-slate-600 dark:text-slate-300 font-medium leading-relaxed mb-6 max-w-xl">
              Most marketing leaders think they're spending $150K on martech. The reality? Often $400K+ when you calculate true total cost. Over 16 years and 75+ implementations, I've developed <strong>The ESCAPE Method™</strong>—a proven six-phase system that helps marketing leaders at $10M-$500M companies consolidate chaotic martech stacks into lean, optimized systems.
            </p>
            
            <div className="mb-6 max-w-xl">
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">The Method:</h3>
              <p className="text-lg font-bold text-brand-red dark:text-brand-yellow tracking-wide">
                EVALUATE &rarr; SIMPLIFY &rarr; CONSOLIDATE &rarr; ALIGN &rarr; PERFECT &rarr; EVOLVE
              </p>
            </div>

            <div className="mb-8 max-w-xl">
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">The Results:</h3>
              <p className="text-lg text-slate-600 dark:text-slate-300 font-medium">
                30-50% cost reduction &bull; 50-100% more time for strategy &bull; 500-1,500% ROI
              </p>
            </div>

            <p className="text-lg text-slate-600 dark:text-slate-300 font-medium leading-relaxed mb-10 max-w-xl">
              My book provides the complete playbook: frameworks, templates, scorecards, and real case studies from successful consolidations. From calculating TCO to establishing governance that prevents backsliding, you'll get everything you need to escape The Tool Trap™ and stay free forever.
            </p>

            <a 
              href="https://www.paypal.com/ncp/payment/6YXHEXV5W8KVL"
              target="_blank" 
              rel="noopener noreferrer" 
              className="inline-flex items-center gap-3 px-8 py-4 bg-brand-dark dark:bg-brand-yellow text-white dark:text-brand-dark text-sm uppercase font-bold tracking-widest hover:bg-brand-red dark:hover:bg-white transition-all duration-300 rounded-lg shadow-xl"
            >
              Pre-Order Now <SafeIcon name="ExternalLink" className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookSection;
